import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import AuthShell, { inputClass, inputShadow } from "@/components/AuthShell";
import { resetPassword, formatApiErrorDetail } from "@/lib/api";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 6) {
      setError("Password needs at least 6 characters.");
      return;
    }
    setBusy(true);
    try {
      await resetPassword({ token, password });
      setDone(true);
      setTimeout(() => navigate("/login", { replace: true }), 1800);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell
      testId="reset-password-page"
      title="NEW PASSWORD"
      subtitle="Pick something you'll remember."
    >
      {!token ? (
        <div data-testid="reset-missing-token" className="font-display text-lg text-navy">
          This reset link is missing its code. Request a new one.
        </div>
      ) : done ? (
        <div data-testid="reset-success" className="font-display text-lg text-navy">
          Password updated! Taking you to log in...
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-3">
          <input
            data-testid="reset-password-input"
            type="password"
            autoComplete="new-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="New password"
            className={inputClass}
            style={inputShadow}
            required
          />
          {error && (
            <div
              data-testid="reset-error"
              className="font-display text-base text-white rounded-2xl border-4 border-navy px-4 py-2"
              style={{ backgroundColor: "#FF5A36" }}
            >
              {error}
            </div>
          )}
          <button
            data-testid="reset-submit-btn"
            type="submit"
            disabled={busy}
            className="chunky-btn w-full py-4 text-2xl text-navy disabled:opacity-50"
            style={{ backgroundColor: "#7CE645" }}
          >
            {busy ? "SAVING..." : "SAVE PASSWORD"}
          </button>
        </form>
      )}

      <div className="mt-5 font-display text-base">
        <Link to="/login" className="text-navy underline">
          Back to log in
        </Link>
      </div>
    </AuthShell>
  );
}
